module.exports = __webpack_public_path__ + "media/images/icon_popup_close_black-0d9003dcb951404a304f0efbeb44bdc4.png";